module.exports = __webpack_public_path__ + "static/media/section-4@3x.bb2e53d8.png";